module.exports = __webpack_public_path__ + "img/title5.adf760b9.png";